export default {
    info: 'Información de perfil',
    email: 'Correo',
    password: 'Clave',
    address: 'Dirección',
    phone: 'Teléfono',
    changePs: 'Cambie su clave',
    transRecord: 'Registro de pago',
    noTransYet: 'No existe transacción',
    logout: 'cerrar sesión',
    age: 'Edad',
    date: 'Fecha',
    orderContent: 'Contenido de pedido',
    orderNumber: 'Número de pedido',
    orderPrice: 'Precio de pedido',
    action: 'Acción',
    title: 'Seguro que quiere cerrar sesión?',
    cancel: 'Cancelar',
    ok: 'sí',
    update: 'Update success',
    typeError: 'file type error',
    sizeError: 'file size error',
    editImg: 'Editar imagen',
    editInfo: 'Editar información',
    editEmail: 'Editar correo',
    editAddress: 'Editar dirección',
    resetPwd: 'Resetear clave',
    phoneInfo: 'Revisar su teléfono para obtener un código de verificación',
    confirm: 'Confirmar',
    successMsg: 'La nueva clave se ha actualizado correctamente!',
    successMsg1: 'Por favor inicie sesión de nuevo.',
    reEnterPwd: 'Re-ingrese clave',
    change: 'Cambiar',
    subOrder: 'Sub-pedido',
    pay: 'Pagar',
    preview: 'Vista previa',
		sentEmail: 'El código de autorización ha sido enviado a {email}. Por favor revise su correo electrónico.',
		codeTxt: 'Código',
		emailErr: 'Debes ingresar una dirección de correo electrónico válida',
}
